<template>
  <b-modal
    v-model="editorShown"
    size="md"
    :scrollable="allowScroll"
    title="Reorder Documents"
    no-close-on-backdrop
    centered
    @ok="submitReorder"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="primary" @click="ok()">
        {{ actionLabel }}
      </b-button>
    </template>
    <b-list-group class="mt-1 p-1 forms-list">
      <draggable v-model="documentOptions">
        <b-list-group-item
          class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
          v-for="(valueItem, valueItemIndex) in documentOptions"
          :key="valueItemIndex"
        >
          <div>
            <b-icon-grip-horizontal></b-icon-grip-horizontal>
            {{ valueItem.label }}
          </div>
        </b-list-group-item>
      </draggable>
    </b-list-group>
  </b-modal>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "DocumentReorder",
  components: { Draggable },
  props: ["documents", "actionLabel"],
  data() {
    return {
      documentOptions: []
    };
  },
  mounted() {
    this.documentOptions = this.documents;
  },
  methods: {
    async submitReorder() {
      this.$emit("onReorder", {
        reorderedDocuments: this.documentOptions
      });
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    allowScroll() {
      return this.documentOptions.length > 1;
    }
  }
};
</script>

<style></style>
